import L from "leaflet";

export const createStationaryIcon = () =>
  L.divIcon({
    className: "",
    iconSize: [160, 32],
    iconAnchor: [12, 16],
    html: `
      <div
        style="
          display:flex;
          align-items:center;
          
        "
      >
        <svg width="26" height="26" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg">
<circle opacity="0.23" cx="13" cy="13" r="13" fill="#F18725"/>
<circle cx="13" cy="13" r="6.5" fill="#F18725"/>
</svg>


      </div>
    `,
  });

export const createRouteLabel = ({
  text,
  borderColor,
  textColor,
  backgroundColor,
}) =>
  L.divIcon({
    className: "",
    iconSize: [120, 40],
    iconAnchor: [20, 32],

    html: `
        <div
          style="
            position: relative;
            display: inline-flex;
            align-items: center;
            justify-content: center;
            padding: 6px 12px;
            background: ${backgroundColor};
            border: 2px solid ${borderColor};
            border-radius: 8px;
            color: ${textColor};
            font-size: 12px;
            font-weight: 500;
            font-family: Poppins, sans-serif;
            white-space: nowrap;
            line-height: 1;
          "
        >
          ${text}
  
          <!-- Outer triangle -->
          <div
            style="
              position:absolute;
              left:10px;
              bottom:-8px;
              width:0;
              height:0;
              border-left:6px solid transparent;
              border-right:6px solid transparent;
              border-top:8px solid ${borderColor};
            "
          ></div>
  
        </div>
      `,
  });

export const createCurrentLocationMarker = ({ isDeviated }) =>
  L.divIcon({
    className: "",
    iconSize: [39, 39],
    iconAnchor: [19.5, 19.5],
    html: `
      <div
        style="
          position: relative;
          width: 39px;
          height: 39px;
          display: flex;
          align-items: center;
          justify-content: center;
        "
      >
        <!-- Background -->
        <svg
          width="39"
          height="39"
          viewBox="0 0 39 39"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          style="position:absolute;left:0;top:0;"
        >
          <circle
            opacity="0.2"
            cx="19.5"
            cy="19.5"
            r="19.5"
            fill="${isDeviated ? "#C84630" : "#085054"}"
          />
        </svg>

        <!-- Foreground -->
        ${
          isDeviated
            ? `
        <svg
          width="33"
          height="33"
          viewBox="0 0 33 33"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          style="position:absolute;left:3px;top:3px;"
        >
          <g clip-path="url(#clip_deviated)">
            <circle
              cx="16.2038"
              cy="16.2054"
              r="11.0526"
              transform="rotate(-80.0663 16.2038 16.2054)"
              fill="#FCFCFC"
            />
            <path
              d="M4.89707 24.1437C9.27922 30.3867 17.9025 31.8969 24.1456 27.5148C30.3885 23.1326 31.8987 14.5093 27.5166 8.26631C23.1344 2.02333 14.5112 0.513098 8.26815 4.89523C2.02517 9.27743 0.51494 17.9007 4.89707 24.1437ZM11.5674 8.29675L25.1619 17.4824C25.4271 17.6677 25.5573 17.9814 25.5033 18.2894L25.4988 18.3151C25.4351 18.6412 25.1803 18.8875 24.8596 18.9438L18.8742 20.0051L15.842 25.2736C15.6801 25.556 15.3619 25.7119 15.0335 25.661C14.7105 25.6177 14.4468 25.3863 14.3649 25.0612L10.346 9.15413C10.2618 8.84187 10.3889 8.49374 10.6604 8.30323C10.9318 8.11271 11.3023 8.11152 11.5674 8.29675Z"
              fill="#C84630"
            />
          </g>
          <defs>
            <clipPath id="clip_deviated">
              <rect
                width="28"
                height="28"
                fill="white"
                transform="translate(0 27.5802) rotate(-80.0663)"
              />
            </clipPath>
          </defs>
        </svg>
        `
            : `
        <svg
          width="33"
          height="33"
          viewBox="0 0 33 33"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          style="position:absolute;left:3px;top:3px;"
        >
          <g clip-path="url(#clip_normal)">
            <circle
              cx="16.2038"
              cy="16.2054"
              r="11.0526"
              transform="rotate(-80.0663 16.2038 16.2054)"
              fill="#FAD152"
            />
            <path
              d="M4.89707 24.1437C9.27922 30.3867 17.9025 31.8969 24.1456 27.5148C30.3885 23.1326 31.8987 14.5093 27.5166 8.26631C23.1344 2.02333 14.5112 0.513098 8.26815 4.89523C2.02517 9.27743 0.51494 17.9007 4.89707 24.1437ZM11.5674 8.29675L25.1619 17.4824C25.4271 17.6677 25.5573 17.9814 25.5033 18.2894L25.4988 18.3151C25.4351 18.6412 25.1803 18.8875 24.8596 18.9438L18.8742 20.0051L15.842 25.2736C15.6801 25.556 15.3619 25.7119 15.0335 25.661C14.7105 25.6177 14.4468 25.3863 14.3649 25.0612L10.346 9.15413C10.2618 8.84187 10.3889 8.49374 10.6604 8.30323C10.9318 8.11271 11.3023 8.11152 11.5674 8.29675Z"
              fill="#085054"
            />
          </g>
          <defs>
            <clipPath id="clip_normal">
              <rect
                width="28"
                height="28"
                fill="white"
                transform="translate(0 27.5802) rotate(-80.0663)"
              />
            </clipPath>
          </defs>
        </svg>
        `
        }
      </div>
    `,
  });

export const generateMockDeviation = (
  fastestRouteCoordinatesInp,
  stopCoordinatesInp,
) => {
  if (!fastestRouteCoordinatesInp?.length || stopCoordinatesInp?.length < 2) {
    return null;
  }

  const startStop = stopCoordinatesInp[0];
  const endStop = stopCoordinatesInp[1];

  const findNearestIndex = (target) => {
    let minDistance = Infinity;
    let nearestIndex = 0;

    fastestRouteCoordinatesInp.forEach((point, index) => {
      const distance =
        Math.abs(point[0] - target[0]) + Math.abs(point[1] - target[1]);

      if (distance < minDistance) {
        minDistance = distance;
        nearestIndex = index;
      }
    });

    return nearestIndex;
  };

  const startIndex = findNearestIndex(startStop);
  const endIndex = findNearestIndex(endStop);

  const plannedCoordinates = fastestRouteCoordinatesInp.slice(
    Math.min(startIndex, endIndex),
    Math.max(startIndex, endIndex) + 1,
  );

  // const actualCoordinates = plannedCoordinates.map(([lat, lng], index) => [
  //   lat + 0.003 * Math.sin(index / 2),
  //   lng + 0.003 * Math.cos(index / 2),
  // ]);

  return {
    plannedCoordinates,
    actualCoordinates: [
      stopCoordinatesInp[0],
      [
        (stopCoordinatesInp[0][0] + stopCoordinatesInp[1][0]) / 2,
        stopCoordinatesInp[0][1],
      ],
      stopCoordinatesInp[1],
    ],
  };
};

// utils/routeDeviation.js

// keeping the older logic for reference

// export const getRouteDeviation = (
//   stopCoordinates = [],
//   gpsRoute = [],
//   threshold = 40, // meters
// ) => {
//   if (stopCoordinates.length < 2 || gpsRoute.length === 0) {
//     return {
//       normalSegments: [],
//       plannedSegments:
//         stopCoordinates.length >= 2 ? [{ coordinates: stopCoordinates }] : [],
//       actualSegments: [],
//       ongoingActualSegment: null,
//       lastMatchedPlanned: -1,
//       gpsMatches: [],
//     };
//   }

//   // ---------------------------------------------------------
//   // DISTANCE
//   // ---------------------------------------------------------

//   const distance = (a, b) => {
//     const R = 6371000;

//     const lat1 = (a[0] * Math.PI) / 180;
//     const lat2 = (b[0] * Math.PI) / 180;

//     const dLat = ((b[0] - a[0]) * Math.PI) / 180;
//     const dLng = ((b[1] - a[1]) * Math.PI) / 180;

//     const sinLat = Math.sin(dLat / 2);
//     const sinLng = Math.sin(dLng / 2);

//     const h =
//       sinLat * sinLat + Math.cos(lat1) * Math.cos(lat2) * sinLng * sinLng;

//     return 2 * R * Math.atan2(Math.sqrt(h), Math.sqrt(1 - h));
//   };

//   // ---------------------------------------------------------
//   // LOCAL XY CONVERSION
//   //
//   // Used only for projecting a GPS point onto a planned
//   // line segment.
//   // ---------------------------------------------------------

//   const origin = stopCoordinates[0];

//   const latScale = 111320;

//   const lngScale = 111320 * Math.cos((origin[0] * Math.PI) / 180);

//   const toXY = ([lat, lng]) => [
//     (lng - origin[1]) * lngScale,
//     (lat - origin[0]) * latScale,
//   ];

//   const toLatLng = ([x, y]) => [
//     y / latScale + origin[0],
//     x / lngScale + origin[1],
//   ];

//   const plannedXY = stopCoordinates.map(toXY);

//   // ---------------------------------------------------------
//   // CLOSEST POINT ON LINE SEGMENT
//   // ---------------------------------------------------------

//   const closestPointOnSegment = (point, start, end) => {
//     const dx = end[0] - start[0];
//     const dy = end[1] - start[1];

//     const lengthSquared = dx * dx + dy * dy;

//     if (lengthSquared === 0) {
//       return {
//         point: start,
//         t: 0,
//       };
//     }

//     let t =
//       ((point[0] - start[0]) * dx + (point[1] - start[1]) * dy) / lengthSquared;

//     t = Math.max(0, Math.min(1, t));

//     return {
//       point: [start[0] + dx * t, start[1] + dy * t],
//       t,
//     };
//   };

//   // ---------------------------------------------------------
//   // FIND CLOSEST POINT ON ENTIRE PLANNED ROUTE
//   // ---------------------------------------------------------

//   const findClosestPlannedPoint = (gps) => {
//     const gpsXY = toXY(gps);

//     let best = null;

//     for (let i = 0; i < plannedXY.length - 1; i += 1) {
//       const projected = closestPointOnSegment(
//         gpsXY,
//         plannedXY[i],
//         plannedXY[i + 1],
//       );

//       const projectedLatLng = toLatLng(projected.point);

//       const d = distance(gps, projectedLatLng);

//       const routePosition = i + projected.t;

//       if (!best || d < best.distance) {
//         best = {
//           segmentIndex: i,
//           t: projected.t,
//           routePosition,
//           distance: d,
//           plannedPoint: projectedLatLng,
//         };
//       }
//     }

//     return best;
//   };

//   // ---------------------------------------------------------
//   // STEP 1
//   //
//   // Match every GPS point to the planned polyline.
//   // ---------------------------------------------------------

//   const gpsMatches = gpsRoute.map((gps, index) => {
//     const match = findClosestPlannedPoint(gps);

//     return {
//       index,
//       gps,

//       segmentIndex: match.segmentIndex,

//       t: match.t,

//       routePosition: match.routePosition,

//       distance: match.distance,

//       plannedPoint: match.plannedPoint,

//       isMatched: match.distance <= threshold,
//     };
//   });

//   // ---------------------------------------------------------
//   // Remove consecutive duplicate coordinates
//   // ---------------------------------------------------------

//   const cleanPoints = (points) =>
//     points.filter((point, index) => {
//       if (index === 0) {
//         return true;
//       }

//       const previous = points[index - 1];

//       return point[0] !== previous[0] || point[1] !== previous[1];
//     });

//   // ---------------------------------------------------------
//   // STEP 2
//   //
//   // Build:
//   //
//   // NORMAL = projected points ON planned route
//   // ACTUAL = real GPS points OFF planned route
//   //
//   // IMPORTANT:
//   // At a transition we use the EXACT projected point.
//   //
//   // This makes:
//   //
//   // normal ───●
//   //            \
//   //             \ actual
//   //
//   // and:
//   //
//   // actual
//   //    /
//   //   ●─── normal
//   //
//   // perfectly connected.
//   // ---------------------------------------------------------

//   const normalSegments = [];
//   const actualSegments = [];

//   let normal = [];
//   let actual = [];

//   let previousMatch = null;

//   gpsMatches.forEach((match) => {
//     // -------------------------------------------------------
//     // GPS IS ON PLANNED ROUTE
//     // -------------------------------------------------------

//     if (match.isMatched) {
//       // We are coming back from deviation
//       if (previousMatch && !previousMatch.isMatched) {
//         /*
//          * End the deviation EXACTLY at the
//          * current projected planned point.
//          */
//         actual.push(match.plannedPoint);

//         if (actual.length >= 2) {
//           actualSegments.push(cleanPoints(actual));
//         }

//         actual = [];

//         /*
//          * Start normal exactly at the same point.
//          */
//         normal.push(match.plannedPoint);
//       } else {
//         /*
//          * Continue normal route.
//          */
//         normal.push(match.plannedPoint);
//       }
//     }

//     // -------------------------------------------------------
//     // GPS IS OFF PLANNED ROUTE
//     // -------------------------------------------------------
//     else {
//       /*
//        * We are leaving the planned route.
//        */
//       if (previousMatch && previousMatch.isMatched) {
//         /*
//          * Start deviation exactly at the last
//          * projected planned point.
//          */
//         actual.push(previousMatch.plannedPoint);

//         /*
//          * Finish normal at exactly the same point.
//          */
//         normal.push(previousMatch.plannedPoint);

//         if (normal.length >= 2) {
//           normalSegments.push(cleanPoints(normal));
//         }

//         normal = [];
//       }

//       /*
//        * Add REAL GPS coordinate.
//        */
//       actual.push(match.gps);
//     }

//     previousMatch = match;
//   });

//   // ---------------------------------------------------------
//   // Flush final normal segment
//   // ---------------------------------------------------------

//   if (normal.length >= 2) {
//     normalSegments.push(cleanPoints(normal));
//   }

//   // ---------------------------------------------------------
//   // Flush final deviation segment
//   // ---------------------------------------------------------

//   if (actual.length >= 2) {
//     actualSegments.push(cleanPoints(actual));
//   }

//   // ---------------------------------------------------------
//   // Remove tiny/invalid segments
//   // ---------------------------------------------------------

//   const validNormalSegments = normalSegments.filter(
//     (segment) => segment.length >= 2,
//   );

//   const validActualSegments = actualSegments.filter(
//     (segment) => segment.length >= 2,
//   );

//   // ---------------------------------------------------------
//   // Last matched planned position
//   // ---------------------------------------------------------

//   let lastMatched = null;

//   for (let i = gpsMatches.length - 1; i >= 0; i -= 1) {
//     if (gpsMatches[i].isMatched) {
//       lastMatched = gpsMatches[i];
//       break;
//     }
//   }

//   // ---------------------------------------------------------
//   // IMPORTANT:
//   //
//   // THE ENTIRE PLANNED ROUTE IS ALWAYS PRESENT.
//   //
//   // We render it underneath everything as the dotted
//   // "best path".
//   //
//   // Normal + actual simply overlay portions of it.
//   // ---------------------------------------------------------

//   const plannedSegments = [
//     {
//       coordinates: [...stopCoordinates],
//     },
//   ];

//   return {
//     normalSegments: validNormalSegments,

//     plannedSegments,

//     actualSegments: validActualSegments,

//     ongoingActualSegment:
//       validActualSegments.length > 0
//         ? validActualSegments[validActualSegments.length - 1]
//         : null,

//     lastMatchedPlanned: lastMatched?.segmentIndex ?? -1,

//     gpsMatches,
//   };
// };

export const getRouteDeviation = (
  stopCoordinates = [],
  gpsRoute = [],
  threshold = 30, // meters
) => {
  if (stopCoordinates.length < 2 || gpsRoute.length === 0) {
    return {
      normalSegments: [],
      plannedSegments:
        stopCoordinates.length >= 2 ? [{ coordinates: stopCoordinates }] : [],
      actualSegments: [],
      ongoingActualSegment: null,
      lastMatchedPlanned: -1,
      gpsMatches: [],
    };
  }

  // =========================================================
  // DISTANCE BETWEEN TWO LAT/LNG POINTS
  // =========================================================

  const distance = (a, b) => {
    const R = 6371000;

    const lat1 = (a[0] * Math.PI) / 180;
    const lat2 = (b[0] * Math.PI) / 180;

    const dLat = ((b[0] - a[0]) * Math.PI) / 180;

    const dLng = ((b[1] - a[1]) * Math.PI) / 180;

    const sinLat = Math.sin(dLat / 2);
    const sinLng = Math.sin(dLng / 2);

    const h =
      sinLat * sinLat + Math.cos(lat1) * Math.cos(lat2) * sinLng * sinLng;

    return 2 * R * Math.atan2(Math.sqrt(h), Math.sqrt(1 - h));
  };

  // =========================================================
  // LOCAL XY
  // =========================================================

  const origin = stopCoordinates[0];

  const latScale = 111320;

  const lngScale = 111320 * Math.cos((origin[0] * Math.PI) / 180);

  const toXY = ([lat, lng]) => [
    (lng - origin[1]) * lngScale,
    (lat - origin[0]) * latScale,
  ];

  const toLatLng = ([x, y]) => [
    y / latScale + origin[0],
    x / lngScale + origin[1],
  ];

  const plannedXY = stopCoordinates.map(toXY);

  // =========================================================
  // CLOSEST POINT ON ONE PLANNED SEGMENT
  // =========================================================

  const closestPointOnSegment = (point, start, end) => {
    const dx = end[0] - start[0];
    const dy = end[1] - start[1];

    const lengthSquared = dx * dx + dy * dy;

    if (lengthSquared === 0) {
      return {
        point: start,
        t: 0,
      };
    }

    let t =
      ((point[0] - start[0]) * dx + (point[1] - start[1]) * dy) / lengthSquared;

    t = Math.max(0, Math.min(1, t));

    return {
      point: [start[0] + dx * t, start[1] + dy * t],
      t,
    };
  };

  // =========================================================
  // FIND CLOSEST POINT ON ENTIRE PLANNED LINE
  //
  // THIS IS THE ONLY MATCHING RULE:
  //
  // GPS -> nearest planned LINE SEGMENT
  //
  // <= threshold = NORMAL
  // > threshold  = DEVIATION
  // =========================================================

  const findClosestPlannedPoint = (gps) => {
    const gpsXY = toXY(gps);

    let best = null;

    for (let i = 0; i < plannedXY.length - 1; i += 1) {
      const projected = closestPointOnSegment(
        gpsXY,
        plannedXY[i],
        plannedXY[i + 1],
      );

      const projectedLatLng = toLatLng(projected.point);

      const d = distance(gps, projectedLatLng);

      if (!best || d < best.distance) {
        best = {
          segmentIndex: i,
          t: projected.t,
          distance: d,
          plannedPoint: projectedLatLng,
        };
      }
    }

    return best;
  };

  // =========================================================
  // STEP 1
  //
  // CLASSIFY EVERY GPS POINT
  //
  // <= 40m from planned LINE = NORMAL
  // > 40m from planned LINE  = DEVIATION
  // =========================================================

  const gpsMatches = gpsRoute.map((gps, index) => {
    const match = findClosestPlannedPoint(gps);

    return {
      index,
      gps,

      segmentIndex: match.segmentIndex,

      t: match.t,

      distance: match.distance,

      plannedPoint: match.plannedPoint,

      isMatched: match.distance <= threshold,
    };
  });

  // =========================================================
  // REMOVE DUPLICATE POINTS
  // =========================================================

  const cleanPoints = (points) =>
    points.filter((point, index) => {
      if (index === 0) {
        return true;
      }

      const previous = points[index - 1];

      return point[0] !== previous[0] || point[1] !== previous[1];
    });

  // =========================================================
  // STEP 2
  //
  // BUILD NORMAL + DEVIATION SEGMENTS
  // =========================================================

  const normalSegments = [];
  const actualSegments = [];

  let normal = [];
  let actual = [];

  let previousMatch = null;

  gpsMatches.forEach((match) => {
    // =======================================================
    // NORMAL
    // =======================================================

    if (match.isMatched) {
      // -----------------------------------------------------
      // REJOIN FROM DEVIATION
      // -----------------------------------------------------

      if (previousMatch && !previousMatch.isMatched) {
        /*
         * Connect actual deviation exactly to
         * the planned route.
         */
        actual.push(match.plannedPoint);

        if (actual.length >= 2) {
          actualSegments.push(cleanPoints(actual));
        }

        actual = [];

        /*
         * Start normal at exactly the same point.
         */
        normal.push(match.plannedPoint);
      } else {
        /*
         * Normal GPS point.
         *
         * Use its projected position on the
         * planned line so the normal line follows
         * the planned route exactly.
         */
        normal.push(match.plannedPoint);
      }
    }

    // =======================================================
    // DEVIATION
    // =======================================================
    else {
      /*
       * We just left the planned route.
       */
      if (previousMatch && previousMatch.isMatched) {
        /*
         * Finish normal exactly at the point
         * where the vehicle left the route.
         */
        normal.push(previousMatch.plannedPoint);

        if (normal.length >= 2) {
          normalSegments.push(cleanPoints(normal));
        }

        normal = [];

        /*
         * Start actual deviation at the exact
         * same planned point.
         */
        actual.push(previousMatch.plannedPoint);
      }

      /*
       * Use the REAL GPS coordinate.
       */
      actual.push(match.gps);
    }

    previousMatch = match;
  });

  // =========================================================
  // FLUSH NORMAL
  // =========================================================

  if (normal.length >= 2) {
    normalSegments.push(cleanPoints(normal));
  }

  // =========================================================
  // FLUSH DEVIATION
  // =========================================================

  if (actual.length >= 2) {
    actualSegments.push(cleanPoints(actual));
  }

  // =========================================================
  // VALID SEGMENTS
  // =========================================================

  const validNormalSegments = normalSegments.filter(
    (segment) => segment.length >= 2,
  );

  const validActualSegments = actualSegments.filter(
    (segment) => segment.length >= 2,
  );

  // =========================================================
  // ENTIRE PLANNED ROUTE
  //
  // This stays underneath everything as the dotted route.
  // =========================================================

  const plannedSegments = [
    {
      coordinates: [...stopCoordinates],
    },
  ];

  // =========================================================
  // LAST MATCHED
  // =========================================================

  let lastMatched = null;

  for (let i = gpsMatches.length - 1; i >= 0; i -= 1) {
    if (gpsMatches[i].isMatched) {
      lastMatched = gpsMatches[i];
      break;
    }
  }

  return {
    normalSegments: validNormalSegments,

    plannedSegments,

    actualSegments: validActualSegments,

    ongoingActualSegment:
      validActualSegments.length > 0
        ? validActualSegments[validActualSegments.length - 1]
        : null,

    lastMatchedPlanned: lastMatched?.segmentIndex ?? -1,

    gpsMatches,
  };
};
